export default "__VITE_ASSET__CceSDuHI__"